import React, { useState } from 'react'

import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { errorNotification, successNotification } from '../utils/notification';
import apiService from '../service/api.service';
import usePriceCategoryStore from '../store/CategoryStore';
import { useEffect } from 'react';
var _ = require('lodash');


export default function CategoriesSidebarSingleNew({ handleCreateNew }) {
    const categories = usePriceCategoryStore((state) => state.selectedData);
    const setCategoryRenewData = usePriceCategoryStore((state) => state.setSelectedData);

    const [sameCategory, setSameCategory] = useState(false);
    const [formValues, setFormValues] = useState({
        slug: "",
        title: "",
        description: ""
    });


    const _handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const emptyFields = [];

            if (emptyFields.title === "") {
                emptyFields.push("Kategori Adı");
            }
            if (emptyFields.slug === "") {
                emptyFields.push("Kategori Slug");
            }
            if (emptyFields.description === "") {
                emptyFields.push("Kategori Açıklaması");
            }

            if (emptyFields.length > 0) {
                errorNotification(
                    `\n${emptyFields.join("\n")},\n alanlarını doldurunuz.`
                );
                return;

            }

            const findItem = _.find(categories, { title: formValues.title });
            const findSlug = _.find(categories, { slug: formValues.slug });


            // Search category array and if item exist return error
            if (findItem || findSlug) {
                errorNotification("\n Bu kategori veya slug zaten mevcut.")
                setSameCategory(findItem || findSlug)
                return;
            }

            const generatedData = {
                description: formValues.description,
                title: formValues.title,
                slug: formValues.slug,
            };

            await apiService.post("prices-category/new", generatedData);

            const getData = await apiService.getByQuery("prices-category/by-query");
            setCategoryRenewData(getData.data);
            setFormValues({
                slug: "",
                title: "",
                description: ""
            });
            handleCreateNew();
            successNotification("Kategori başarıyla eklendi.");
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <Card className='mb-2' style={{ border: "none", borderBottom: '2px solid #fafafa' }}>
            <Card.Body style={{ padding: 5 }}>
                <h6 style={{ marginBottom: 0 }}>Yeni Kategori Ekle</h6>
                {sameCategory && <div className="mt-3 mb-3">
                    <Alert variant='danger' dismissible={() => {
                        setSameCategory(false)
                    }}>
                        <h6> Bu veri zaten mevcut! </h6>
                        <code>
                            {JSON.stringify(sameCategory)}
                        </code>
                    </Alert>
                </div>}
                <Form className='mt-3 mb-3' onSubmit={(e) => e.preventDefault()}>
                    <Row>
                        <Col md="8">
                            <Form.Label >Kategori Adı</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Kategori "
                                value={formValues.title}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, title: e.target.value })
                                }
                            />
                        </Col>
                        <Col md="4">
                            <Form.Label >Slug</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Slug"
                                value={formValues.slug}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, slug: e.target.value })
                                }
                            />
                        </Col>
                        <Col md="12 mt-2">
                            <Form.Label >Kategori Açıklaması</Form.Label>
                            <Form.Control
                                as="textarea" rows="3"
                                placeholder="Kategori açıklaması"
                                value={formValues.description}
                                onChange={(e) =>
                                    setFormValues({ ...formValues, description: e.target.value })
                                }
                            />
                        </Col>



                        <Col md="12" className="mt-3">
                            <div className="d-flex justify-content-end">
                                <div className="mx-2">
                                    <Button variant="light" disabled={false} onClick={handleCreateNew} >
                                        Vazgeç
                                    </Button>
                                </div>
                                <Button variant="success" onClick={_handleSubmit} disabled={false}>
                                    Ekle
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    )
}